import Icon, { IconProps } from './Icon';

import ServerIcon from '../../../assets/icons/server-04.svg?react';

const Server: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <ServerIcon />
    </Icon>
  );
};

export default Server;
